import type { FaireProductEntity } from "../../entity_types/product";

export const p_y46bh2p7x4: FaireProductEntity = {
  token: "p_y46bh2p7x4",
  type: "product",
  name: "Pineapple Rings - Organic, Dried",
  brandName: "Wilderness Poets",
  imageUrl:
    "https://cdn.faire.com/fastly/12b9d6877b19430f9e399f84715747889013f199bb7e52680f55f631f0247152.png",
  priceDollars: 8.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/64b942cfb64ee742950dd77ea08ac24469fec9b5bbd1654391cd5cb6e7c45857.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
